import React from 'react';
import {Link, NavLink, Route, Routes, useNavigate} from "react-router-dom";
import {withRouter} from "./withRouter";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {TwitterShareButton} from "react-share";

class SearchGame extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            result: null
        };
    }

    search(keyword){
        fetch(process.env.REACT_APP_API_URL + "/customer/game/search/" + keyword)
            .then(res => res.json())
            .then(
                (result) => {
                    console.log(result);
                    this.setState({
                        isLoaded: true,
                        result: result
                    });
                },

                (error) => {
                    console.log(error);

                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    componentDidMount() {
        if(this.props.search) {
            this.search(this.props.search);
        }
    }

    handleSearch(e) {
        e.preventDefault();

        const {navigate} = this.props;

        if(e.target.search.value.length > 0) {
            this.search(e.target.search.value);
            navigate('/games/search/' + e.target.search.value);
        }
    };


    render() {
        const {isLoaded, error, result} = this.state;

        const searchBar = <Form className="d-flex col-sm-4" onSubmit={this.handleSearch.bind(this)}>
            {/* eslint-disable-next-line react/react-in-jsx-scope */}
            <Form.Control
                type="search"
                name="search"
                placeholder="Search"
                className="me-2"
                aria-label="Search"

            />
            {/* eslint-disable-next-line react/react-in-jsx-scope */}
            <Button type="submit" variant="outline-success">Search</Button>
        </Form>;

        if (error) {
            return <h3>{searchBar}<br/>Something went wrong</h3>
        } else if (!isLoaded) {
            return <h3>Loading...</h3>
        } else {
            return <div>

                <div className="album py-5 bg-body-tertiary">
                    <div className="container">
                        {searchBar}
                        <br/>
                        <h2>Search results</h2>
                        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
                {result.map(item => (<div className="col">
                    <div className="card shadow-sm">
                        <div className="bd-placeholder-img card-img-top" style={{
                            width: "100%",
                            height: "225px"
                        }}>
                            <img
                                src={item.game_page ? item.game_page.background_image_url : "http://www.w3.org/2000/svg"}
                                width="100%" height="100%"/>
                        </div>
                        <div className="card-body" style={{
                            color: "darkgray"
                        }}>
                            <p className="card-text">{item.name}</p>
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="btn-group">
                                    <button type="button" className="btn btn-sm btn-outline-secondary">
                                        <a style={{
                                            textDecoration: "none",
                                            color: "darkgray"
                                        }} href={"/games/" + item.id.toString()}>Download</a>
                                    </button>
                                    <button type="button" className="btn btn-sm btn-outline-secondary">
                                                    <span
                                                    >
                                                    <TwitterShareButton
                                                        url={"https://easy-street.herokuapp.com/games/" + item.id.toString()}
                                                        quote={item.name}
                                                        hashtag="#easystreet"
                                                    >
                                                        Share
                                                    </TwitterShareButton>
                                                </span>
                                    </button>
                                </div>
                                <small
                                    className="text-body-secondary">
                                    {item.status !== 'active' ?
                                        <span style={{
                                            float: "right",
                                            backgroundColor: "#ffea2b",
                                            color: "#faf19d",
                                            borderRadius: 5,
                                            fontWeight: "bold",
                                            capacity: 1,
                                            paddingLeft: 5,
                                            paddingRight: 5
                                        }}>
                                            {item.status.replace('_', ' ').replace('_', ' ')}
                                        </span>
                                        : item.genre.charAt(0).toUpperCase() + item.genre.slice(1)
                                    }
                                </small>
                            </div>
                        </div>
                    </div>
                </div>))}
                        </div>
                    </div>
                </div>
                <br/>
            </div>;
        }
    }
}

export default withRouter(SearchGame);
